// Local-only capture: no network calls or media uploads.
export function stopTracks(stream) {
  stream?.getTracks().forEach((track) => track.stop());
}

export function recorderOptions(Recorder) {
  const mimeType = ['video/mp4', 'video/webm;codecs=vp8,opus', 'video/webm']
    .find((type) => Recorder.isTypeSupported?.(type));
  return { ...(mimeType ? { mimeType } : {}), videoBitsPerSecond: 2500000 };
}

export function cameraConstraints(facingMode, audio) {
  return { video: { facingMode: { ideal: facingMode }, width: { ideal: 1280 },
    height: { ideal: 720 }, frameRate: { ideal: 24, max: 30 } }, audio };
}

export function conversationText(conversation) {
  return [conversation.title || 'OmniChat conversation', '', ...(conversation.messages || [])
    .map((item) => `${item.role === 'you' ? 'You' : 'OmniChat'}:\n${item.text || ''}`)].join('\n\n');
}
